import { BrokerUser } from '@insurance/api/requests'
import { useSessionContext } from '@shared/hooks'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getActionColumnMenu } from './tableActions'
import { getTableColumns } from './tableColumns'
import { AgentActionsTypes, AgentsActions } from '../AgentsActions'

type Props = {
  brokerId?: string
  data?: BrokerUser[]
  triggerSort: (sorter: SorterResult<BrokerUser>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<BrokerUser>
  ) => TableColumnsType<BrokerUser>
} & TableProps<BrokerUser>

export const AgentsTable = ({
  brokerId,
  data,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const { broker } = useSessionContext()
  const [modal, setModal] = useState<{
    type: AgentActionsTypes
    data: BrokerUser
  } | null>(null)

  const columns = getSortedTableColumns(
    getTableColumns(
      getActionColumnMenu(setModal, t, !!broker?.user?.is_broker_admin),
      t
    )
  )

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        onChange={(_, __, sorter) =>
          triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
        }
        scroll={{ x: 'max-content' }}
        {...props}
      />

      {modal && (
        <AgentsActions
          open
          brokerId={brokerId}
          onCancel={() => setModal(null)}
          onSuccess={() => setModal(null)}
          {...modal}
        />
      )}
    </>
  )
}
